<template>
    <b-sidebar
        v-model="localIsOpen"
        id="user-motivation-details-sidebar"
        right
        backdrop
        shadow
        width="80em"
        backdrop-variant="dark"
        @change="onSidebarChange"
    >
        <template #title>
            <div>
                <strong>{{ userData && userData.name ? userData.name : 'Пользователь' }}</strong>
            </div>
        </template>

        <!-- Content -->
        <div class="sidebar-body p-3">
            <LogisticsPersonalStats 
                v-if="userData && userData.id"
                :user-id="userData.id" 
                :period="period"
                :hide-motivation-text="true"
                :compact-mode="true"
                :open-in-new-window="true"
            />
            <div v-else class="text-center py-4">
                <p class="text-muted">Выберите пользователя для просмотра деталей</p>
            </div>
        </div>
    </b-sidebar>
</template>

<script>
import LogisticsPersonalStats from './LogisticsPersonalStats.vue'

export default {
    name: 'UserDetailsSidebar',
    components: {
        LogisticsPersonalStats
    },
    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
        userData: {
            type: Object,
            default: () => ({})
        },
        period: {
            type: String,
            default: 'current'
        }
    },
    data() {
        return {
        }
    },
    computed: {
        localIsOpen: {
            get() {
                return this.isOpen
            },
            set(value) {
                // Не мутируем пропс напрямую, только эмитим событие
                if (!value) {
                    this.$emit('close')
                }
            }
        }
    },
    watch: {
        isOpen(newVal) {
            // Синхронизируем локальное состояние с пропсом
            if (newVal && !this.localIsOpen) {
                this.$nextTick(() => {
                    this.localIsOpen = newVal
                })
            }
        }
    },
    methods: {
        onSidebarChange(isOpen) {
            // Эмитим событие закрытия, но не мутируем пропс
            if (!isOpen) {
                this.$emit('close')
            }
        }
    }
}
</script>

<style scoped>
/* Стили для заголовка сайдбара */
.sidebar-header {
    background: linear-gradient(135deg, #0D6247 0%, #1a7a5e 100%);
    color: white;
    border-bottom: 2px solid #0D6247;
}

.sidebar-header h5 {
    color: white !important;
    font-weight: 600;
}

.sidebar-header .fas {
    color: #EA7B27;
}

/* Компактный режим для сайдбара */
.sidebar-body .logistics-personal-stats {
    padding: 0;
}

.sidebar-body .logistics-personal-stats .card {
    margin-bottom: 1rem;
}

.sidebar-body .logistics-personal-stats .card-header {
    padding: 0.75rem 1rem;
}

.sidebar-body .logistics-personal-stats .card-body {
    padding: 1rem;
}

.sidebar-body .logistics-personal-stats .chart-container {
    height: 300px;
}

.sidebar-body .logistics-personal-stats .table th,
.sidebar-body .logistics-personal-stats .table td {
    padding: 0.5rem;
    font-size: 0.875rem;
}

.sidebar-body .logistics-personal-stats .calculation-step {
    padding: 0.75rem;
}

.sidebar-body .logistics-personal-stats .final-bonus {
    padding: 1rem;
}
</style>
